'use client'

import { useEffect } from 'react'
import { useParams, useRouter } from 'next/navigation'

export default function BookingStudentPage() {
  const { locale } = useParams<{ locale: string }>()
  const router = useRouter()

  useEffect(() => {
    if (!locale) return
    router.replace(`/${locale}/booking-student/registration/`)
  }, [locale, router])

  return null
}
